export const scopeDescriptions = {
  public_profile: 'View your public profile',
  read_wallets: 'View your connected wallets',
};
